var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "calendarPathA",
    d: "M7.463 21h9.074C18.453 21 20 19.442 20 17.512v-9.28c0-1.93-1.547-3.488-3.463-3.488h-.37V3.698c0-.396-.3-.698-.692-.698a.683.683 0 0 0-.693.698v1.046H9.218V3.698c0-.396-.3-.698-.693-.698a.683.683 0 0 0-.692.698v1.046h-.37C5.547 4.744 4 6.302 4 8.233v9.255C4 19.442 5.57 21 7.463 21zm9.097-1.395H7.463a2.077 2.077 0 0 1-2.078-2.093v-6.233h13.23v6.21a2.063 2.063 0 0 1-2.055 2.116zM7.463 6.14h.37V7.65c0 .396.3.698.692.698a.683.683 0 0 0 .693-.698V6.14h5.587V7.65c0 .396.3.698.693.698a.683.683 0 0 0 .692-.698V6.14h.37c1.154 0 2.078.93 2.078 2.093v1.65H5.385v-1.65c0-1.14.947-2.093 2.078-2.093z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#6173FE",
    fillRule: "evenodd",
    xlinkHref: "#calendarPathA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.65ac31b8.svg";
export { ForwardRef as ReactComponent };